import { apiClient } from "./client";
import type { DetailFieldsResponse } from "./types";

/**
 * Fetch the per-project Company-detail field catalog.
 *
 * Sourced from `project_type.features.detail_fields` and grouped by
 * section. The operator-selected visibility subset (if any) lives on
 * `Project.config.visible_detail_fields` — `DynamicDetailFields`
 * cross-references it client-side so a single fetch drives the
 * panel.
 */
export async function getDetailFields(
  slug: string,
): Promise<DetailFieldsResponse> {
  const res = await apiClient.get<DetailFieldsResponse>(
    `/projects/${slug}/detail-fields`,
  );
  return res.data;
}
